module.exports = __webpack_public_path__ + "img/woman-waking.d391a0f9.png";